import React, { useEffect, useState } from "react";
// import videojs from "video.js";
import VideoJS from "./videoJS";
import LoadingIndicatorHeader from "../loading-indicator/loading-indicator-header";
import util from "../util/util";

export default function Livestream() {
  // player Ref
  const playerRef = React.useRef(null);
  // indicator for when the backend has responded with the source url, so we can load the player
  const [loaded, setLoaded] = useState(false);
  // player Options
  const [videoJsOptions, setVideoJsOptions] = useState({
    autoplay: false,
    controls: true,
    responsive: true,
    fluid: true,
    liveui: true,
    controlBar: {
      pictureInPictureToggle: false
    },
    sources: [
      {
        src: "",
        type: "application/x-mpegURL"
      }
    ]
  });

  useEffect(() => {
    const getLivestreamData = () => {
      // getting the 'src' (and in future possibly other data ?) from the backend
      util.getLivestreamData().then(data => {
        setVideoJsOptions(videoJsOptions => ({
          ...videoJsOptions,
          sources: [
            {
              ...videoJsOptions.sources[0],
              src: data.source_url
            }
          ]
        }));
        setLoaded(true);
      });
    };

    getLivestreamData();
  }, []);

  const handlePlayerReady = player => {
    playerRef.current = player;

    // You can handle player events here, for example:
    // player.on("waiting", () => {
    //   videojs.log("player is waiting");
    // });
    //
    // player.on("dispose", () => {
    //   videojs.log("player will dispose");
    // });
  };

  if (loaded === false) {
    return <LoadingIndicatorHeader />;
  } else {
    return (
      <div>
        <div className="row">
          <div className="col-xs-5">
            <h4 className="page__title">
              Your Station's KIDS 24/7 Localized Livestream
            </h4>
          </div>
        </div>

        <div className="search-form">
          <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />
        </div>

        <div>
          &nbsp;
          <p>
            Use this embedded player for pre-launch testing and post-launch
            monitoring of your livestream and localized pods.
          </p>
        </div>
      </div>
    );
  }
}
